import BeCuponUtils from "@/utils/Utils";

export default class CouponRefererUser {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        referCouponUserRetrieve(id: ${id}) {
          id
          created
          user {
            id
            email
            profile {
              image {
                url
              }
            }
          }
          refererCoupon {
            coupon {
              id
              title
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.refererCouponUserRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query {
        refererCouponUserList(pageSize: 1000) {
          results {
            id
            created
            user {
              id
              email
              }
              refererCoupon {
                coupon {
                  id
                  title
                }
              }              
            }
          }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i = 0; i < response.data.data.refererCouponUserList.results.length; i++) {
      response.data.data.refererCouponUserList.results[i].created = BeCuponUtils.formatDateTime(response.data.data.refererCouponUserList.results[i].created); 
    }

    return response.data.data.refererCouponUserList.results.reverse();
  }
}